module.exports = __webpack_public_path__ + "img/pre_active.f4be2e1f.svg";